import React from "react";
import { getFetcher, postFetcher } from "../../../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import { useForm } from "react-hook-form";
import { isResponseErrorObject } from "../../../../services/helpers";
import toast from "react-hot-toast";
import ControlledReactSelect from "../../../../components/elements/ControlledReactSelect";
import ControlledInput from "../../../../components/elements/ControlledInput";
import { Button, Card, CardBody, CardHeader, Input, Switch } from "@nextui-org/react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import HeaderPage from "../../../../components/elements/HeaderPage";
import { month } from "../../../../services/enum";
import { yupResolver } from "@hookform/resolvers/yup";
import { reportVehicleValidation } from "../../../../services/validation";
import TransportComponent from "../../../../components/fragments/admin/report/transport/TransportComponent";

export default function VehicleCreatePage() {
  const { detailId } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useSWR(`/api/pelaporan-pengangkutan/find/${detailId}`, getFetcher);
  /* Disable agar bisa pilih B3 apa saja
  const { data: dataMaterial, isLoading: isLoadingMaterial } = useSWR(!isLoading && data ? `/api/vehicles/${data?.vehicleId}` : null, getFetcher);
  */
  const { data: dataMaterial, isLoading: isLoadingMaterial } = useSWR(!isLoading && data ? `/api/data-master/bahan-b3?returnAll=true` : null, getFetcher);

  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: yupResolver(reportVehicleValidation) });

  async function onSubmitForm(formData) {
    try {
      const payload = {
        b3SubstanceId: formData.b3SubstanceId,
        jumlahB3: formData.jumlahB3,
        perusahaanAsalMuatDanTujuanBongkar: formData?.perusahaanAsalMuatDanTujuanBongkar?.map((item) => ({
          perusahaanAsalMuatId: item.perusahaanAsalMuat.perusahaanAsalMuatId,
          locationType: item.perusahaanAsalMuat.locationType,
          longitudeAsalMuat: item.perusahaanAsalMuat.longitudeAsalMuat,
          latitudeAsalMuat: item.perusahaanAsalMuat.latitudeAsalMuat,
          perusahaanTujuanBongkar: item.perusahaanTujuanBongkar?.map((item) => ({
            perusahaanTujuanBongkarId: item.perusahaanTujuanBongkarId,
            locationType: item.locationType,
            longitudeTujuanBongkar: item.longitudeTujuanBongkar,
            latitudeTujuanBokar: item.latitudeTujuanBokar,
            jumlaBahanB3DiAngkut: parseInt(item.jumlahDiAngkut),
            jumlaBahanB3DiBongkar: parseInt(item.jumlahDiBongkar),
          })),
        })),
      };
      console.log(payload);

      await postFetcher(`/api/pelaporan-pengangkutan/add/${data?.id}`, payload);
      toast.success("Laporan pengangkutan berhasil dibuat");
      // redirect
      navigate(-1);
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
    }
  }

  return (
    <RootAdmin>
      <HeaderPage title={`${data?.vehicle?.modelKendaraan} / ${data?.vehicle?.noPolisi}`} subtitle={"Buat Riwayat Pengangkutan"} />
      <Card radius="sm" className="mt-3">
        <CardHeader></CardHeader>
        <CardBody>
          <form onSubmit={handleSubmit(onSubmitForm)} className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <Input label="Periode" labelPlacement="outside" isRequired isDisabled value={data?.period.name} />
            <Input label="Bulan" labelPlacement="outside" isRequired isDisabled value={month[data?.bulan - 1]} />
            <Input label="Tahun" labelPlacement="outside" isRequired isDisabled value={data?.tahun} />
            <div className="col-span-2">
              <ControlledReactSelect
              /*
                options={dataMaterial?.BahanB3Kendaraan?.map((item) => ({
                  value: item.dataBahanB3Id,
                  label: `${item.dataBahanB3.casNumber} - ${item.dataBahanB3.namaBahanKimia}`,
                }))}
              */
                options={dataMaterial?.data?.map((item) => ({ value: item.id, label: `${item.casNumber} - ${item.namaBahanKimia}` }))}
                control={control}
                isLoading={isLoadingMaterial}
                label="Bahan B3"
                name="b3SubstanceId"
              />
            </div>

            <div className="col-span-3">
              <TransportComponent companyId={data?.companyId} control={control} setValue={setValue} errors={errors} />
            </div>

            <div className="mt-3 space-x-2">
              <Button isDisabled={isSubmitting} isLoading={isSubmitting} color="primary" type="submit">
                Simpan
              </Button>
              <Button onPress={() => navigate(-1)} color="warning" variant="flat">
                Kembali
              </Button>
            </div>
          </form>
        </CardBody>
      </Card>
    </RootAdmin>
  );
}
